.root {
  border-top: 1px solid var(--color-border);
  background: var(--color-surface);
  padding: 14px clamp(16px, 4vw, 48px) 16px;
}

.inputRow {
  max-width: var(--content-max-width);
  margin: 0 auto;
  display: flex;
  align-items: flex-end;
  gap: 10px;
  padding: 8px 8px 8px 16px;
  border-radius: var(--radius-lg);
  border: 1.5px solid var(--color-border);
  background: var(--color-surface-subtle);
  transition: border-color var(--duration-fast) var(--ease-standard),
    box-shadow var(--duration-fast) var(--ease-standard);
}

.inputRow:focus-within {
  border-color: var(--color-brand-primary);
  box-shadow: 0 0 0 3px var(--color-brand-primary-soft);
}

.textarea {
  flex: 1;
  resize: none;
  border: none;
  background: transparent;
  font-family: var(--font-sans);
  font-size: 14.5px;
  line-height: 1.5;
  color: var(--color-text);
  max-height: 160px;
  padding: 7px 0;
}

.textarea:focus {
  outline: none;
}

.textarea::placeholder {
  color: var(--color-text-tertiary);
}

.textarea:disabled {
  opacity: 0.6;
}

.sendButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  border-radius: var(--radius-md);
  border: none;
  background: var(--color-brand-primary);
  color: var(--color-text-on-brand);
  cursor: pointer;
  transition: background var(--duration-fast) var(--ease-standard),
    transform var(--duration-fast) var(--ease-standard);
}

.sendButton:hover:not(:disabled) {
  background: var(--color-brand-primary-strong);
}

.sendButton:active:not(:disabled) {
  transform: scale(0.94);
}

.sendButton:disabled {
  background: var(--color-border-strong);
  cursor: not-allowed;
}

.footnote {
  max-width: var(--content-max-width);
  margin: 8px auto 0;
  font-size: 11.5px;
  color: var(--color-text-tertiary);
  text-align: center;
}
